import baseApi from './base';
import {
  ScormCookieTag,
  ScormVocamVideoLinkTag,
} from '@/modules/services/tags';
import { ScormTokenData } from '@/modules/types/scorm';
import config from '@/lib/config/index';
import { getContentTypeResponse } from '@/lib/util';

interface ScormTokenParam {
  token: string;
}

interface ScormDownloadParam {
  elearningId: string;
}

// Special base URL for anonymous SCORM endpoints
const API_PREFIX = config.api.enableBFF ? '/api' : '';
const ANON_BASE_URL = `${config.api.baseUrl}${API_PREFIX}/anon/v1/`;

const scormApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getScormSignedCookies: build.query<ScormTokenData, ScormTokenParam>({
      query: (params) => ({
        url: `${ANON_BASE_URL}scorm/signed-cookies/generate`,
        params,
      }),
      providesTags: [ScormCookieTag],
    }),
    downloadScormPackage: build.mutation<Blob, ScormDownloadParam>({
      query: ({ elearningId }) => ({
        url: `/elearnings/${elearningId}/scorm/download`,
        method: 'GET',
        responseHandler: (response) => response.blob(),
      }),
    }),
    getScormVocamVideoLink: build.query<
      string,
      { token: string; moduleId: number; topicId: number }
    >({
      query: (param) => ({
        url: `${ANON_BASE_URL}scorm/vocam-video-link/${param.moduleId}/${param.topicId}`,
        params: { token: param.token },
        responseHandler: getContentTypeResponse,
        // Add data to cache with 5 minutes persistent
        keepUnusedDataFor: 300,
      }),
      providesTags: [ScormVocamVideoLinkTag],
    }),
  }),
  overrideExisting: false,
});

export default scormApi;
